import * as React from 'react'
import { INews } from 'src/type/news'
import { WithStyles, CardActions, Theme, createStyles, withStyles } from '@material-ui/core'
import { compose } from 'redux'
import {
    LinkedinShareButton,
    TwitterShareButton,
    TwitterIcon,
    LinkedinIcon
} from 'react-share'

const styles = (t: Theme) => createStyles({
    actions: {
      display: 'flex',
      marginTop: 'auto'
    },
    center: {
        justifyContent: 'center',
    },
    end: {
      justifyContent: 'flex-end',
    },
    start: {
        justifyContent: 'flex-start',
    },
    btnShare:{
        margin: '0 8px',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.75
        }
    }
  });

interface IProps extends WithStyles<typeof styles>{
    post: INews;
    position?: string;
}

class NewsShare extends React.Component<IProps, {}> {
    render() {
        const {classes, post, position} = this.props
        return (
          <>     
            <CardActions 
                key={`news-card-actionsa-${post.id}`}  
                className={`${classes.actions} ${!!position ? classes[position] : ""}`} 
                disableActionSpacing
            >
                <TwitterShareButton 
                    className={classes.btnShare}
                    key={`news-card-share-tw-${post.id}`}
                    url={window.location.href}
                    via="Salle des Marchés du Groupe ARKEA"
                    title={post.title}
                    hashtagRendering={this.hashtagRendering()}
                >
                    <TwitterIcon size={32} round/>
                </TwitterShareButton>
                <LinkedinShareButton 
                    className={classes.btnShare}
                    key={`news-card-share-lk-${post.id}`} 
                    url={window.location.href}
                    title={post.title}
                >
                    <LinkedinIcon size={32} round/>
                </LinkedinShareButton>
            </CardActions>
          </>
        )
    } 

    private hashtagRendering(){
        const {post} = this.props
        let hashtag = []
        if(post.category_actu){
            hashtag = hashtag.concat(post.category_actu.split(","))
        }
        if(post.category_actu_nuage){
            hashtag = hashtag.concat(post.category_actu_nuage.split(","))
        }
        if(post.category_principale){
            hashtag = hashtag.concat(post.category_principale.split(","))
        }
        if(post.category_produit){
            hashtag = hashtag.concat(post.category_produit.split(","))
        }
        return hashtag
    }
}

export default compose(    
    withStyles(styles)
)(NewsShare)


// WEBPACK FOOTER //
// ./src/shared/News/NewsShare.tsx